import { Code, Copy } from "lucide-react";
import type { MapStyleDiagnosticsPanelProps } from "../../contracts/map-styles";
import { cn } from "../../lib/utils";
import { MapAssetStatList } from "../map-assets/MapAssetStatList";

/**
 * A panel for inspecting the generated JSON and runtime facts of a map style.
 */
export function MapStyleDiagnosticsPanel({
  title,
  description,
  summaryItems = [],
  generatedJson,
  helperText,
  onCopyJson,
  className,
}: MapStyleDiagnosticsPanelProps) {
  return (
    <div className={cn("flex flex-col gap-4 h-full", className)}>
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Code className="h-4 w-4 text-muted-foreground" />
            <h3 className="text-xs font-black uppercase tracking-wider text-foreground">
              {title}
            </h3>
          </div>
          {onCopyJson && (
            <button
              onClick={onCopyJson}
              className="p-1 rounded hover:bg-muted text-muted-foreground transition-colors"
              title="Copy JSON"
            >
              <Copy className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
        {description && (
          <p className="text-[10px] text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
      </div>

      {summaryItems && summaryItems.length > 0 && (
        <div className="p-3 rounded-lg bg-background border border-border/50 shadow-sm">
          <MapAssetStatList items={summaryItems} />
        </div>
      )}

      <div className="flex-1 min-h-0 flex flex-col gap-2">
        <div className="flex-1 relative rounded-lg border border-border bg-muted/20 overflow-hidden">
          <textarea
            readOnly
            value={generatedJson}
            className="w-full h-full p-3 font-mono text-[10px] bg-transparent resize-none focus:outline-none"
            spellCheck={false}
          />
        </div>
        {helperText && (
          <p className="text-[9px] font-medium text-muted-foreground italic px-1">
            {helperText}
          </p>
        )}
      </div>
    </div>
  );
}
